export default {
  // 支付结果页面
  result: {
    title: '支付结果',
    success: {
      title: '支付成功',
      message: '支付成功，请关闭本页面。',
      loading: '加载中...'
    },
    failed: {
      title: '支付失败',
      message: '支付失败，请关闭本页面后重试或联系我们。'
    }
  },
  
  // 通用支付相关
  common: {
    loading: '加载中...',
    close: '关闭',
    tryAgain: '重试',
    back: '返回'
  }
};
